import { Slot } from "expo-router";

import { api } from "~/utils/api";
import { ResultsLayout } from "~/component/layout/layout";
import { ResultsContext } from "~/contexts/ResultsContext";

const Layout = () => {
  const [tasksStatus] = api.home.tasksStatus.useSuspenseQuery();

  return (
    <ResultsContext.Provider value={{ tasksStatus }}>
      <ResultsLayout>
        <Slot />
      </ResultsLayout>
    </ResultsContext.Provider>
  );
};

export default Layout;
